import { type ComponentType, lazy } from 'react';

export type Deck = {
  slug: string;
  title: string;
  /** Who presents it. Filter the index with `?owner=<owner>`. */
  owner: string;
  component: ComponentType;
};

/**
 * Every slide deck, newest first — the index renders them in this order and
 * `/presentations/:slug` resolves against it. Lazy so decks stay out of the
 * main bundle: nobody using the app should download them.
 */
const DECKS: Deck[] = [
  {
    slug: 'demo-day-2026-08-26-jedelacarrera',
    title: 'Demo Day 53 — Jorge de la Carrera',
    owner: 'jorge',
    component: lazy(() => import('pages/DemoDay/20260826Jorge')),
  },
  {
    slug: 'autoland-colombia',
    title: 'Autoland Colombia — Debrief',
    owner: 'jorge',
    component: lazy(() => import('pages/AutolandColombia')),
  },
  {
    slug: 'prompt-caching',
    title: 'Prompt Caching',
    owner: 'jorge',
    component: lazy(() => import('pages/PromptCachingPresentation')),
  },
  {
    slug: 'tech-lead-tomas',
    title: 'Tomás — Tech Lead',
    owner: 'jorge',
    component: lazy(() => import('pages/TechLeadTomas')),
  },
  {
    slug: 'demo-day-2026-07-30-jedelacarrera',
    title: 'Demo Day — Jorge de la Carrera',
    owner: 'jorge',
    component: lazy(() => import('pages/DemoDay/20260730JorgeDeLaCarrera')),
  },
  {
    slug: 'demo-day-2026-07-02-jedelacarrera',
    title: 'Demo Day — Jorge de la Carrera',
    owner: 'jorge',
    component: lazy(() => import('pages/DemoDay/20260702Jorge')),
  },
  {
    slug: 'demo-day-2026-06-10-jedelacarrera',
    title: 'Demo Day — Jorge de la Carrera',
    owner: 'jorge',
    component: lazy(() => import('pages/DemoDay/20260610Jorge')),
  },
  {
    slug: 'jorge-demo-day-48',
    title: 'Demo Day 48 — Jorge de la Carrera',
    owner: 'jorge',
    component: lazy(() => import('pages/JorgeDemoDay48')),
  },
  {
    slug: 'analytics-nivel-facebook',
    title: 'Analytics nivel Facebook',
    owner: 'jorge',
    component: lazy(() => import('pages/AnalyticsFacebook')),
  },
  {
    slug: 'subestimar-tiempos',
    title: 'Por qué subestimamos los tiempos',
    owner: 'jorge',
    component: lazy(() => import('pages/SubestimarTiempos')),
  },
];

export default DECKS;
